import {USEDPROMOCODE} from '../../../api/apiPaths';
import { get} from '../../../api/commonAPI';
import toastr from 'toastr';
import * as Actions from './PromoCodeActionTypes';

export const getPromoCodeUsage = (promoCode, startDate, endDate) => {
  return dispatch => {
    dispatch({
      type: Actions.FETCH_PROMO_CODE_USAGE
    });
    let url = `${USEDPROMOCODE}/usage/${promoCode}?startDate=${startDate}&endDate=${endDate}`
    get(url)
        .then(res => {
          dispatch({
            type: Actions.FETCH_PROMO_CODE_USAGE_SUCCESS,
            payload: res.data
          });
        })
        .catch(error => {
          dispatch({
            type: Actions.FETCH_PROMO_CODE_USAGE_FAILS,
            payload: error
          });
          toastr.error(error.response.data.errors[0])  
        });
  };
};